import { render, staticRenderFns } from "./CAChart.vue?vue&type=template&id=2f490432&"
import script from "./CAChart.vue?vue&type=script&lang=js&"
export * from "./CAChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports